document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll("#location-input").forEach((inputEl) => {
		/**
		 * Create the lat and lng hidden inputs and append them
		 * to the same form as the location input
		 */
		const latInput = document.createElement("input");
		latInput.type = "hidden";
		latInput.name = "job_lat";
		latInput.id = "lat-input";

		const lngInput = document.createElement("input");
		lngInput.type = "hidden";
		lngInput.name = "job_lng";
		lngInput.id = "lng-input";

		const distanceInput = document.createElement("input");
		distanceInput.type = "hidden";
		distanceInput.name = "distance";
		distanceInput.id = "distance-input";

		inputEl.closest("form").appendChild(latInput);
		inputEl.closest("form").appendChild(lngInput);
		inputEl.closest("form").appendChild(distanceInput);

		const autocomplete = new google.maps.places.Autocomplete(inputEl);

		// Listen for the 'place_changed' event when a user selects an address
		autocomplete.addListener("place_changed", () => {
			const place = autocomplete.getPlace();

			// Update the input value with the selected address
			inputEl.value = place.formatted_address;

			// Update the lat and lng inputs with the selected location
			lngInput.value = place.geometry.location.lng();
			latInput.value = place.geometry.location.lat();

			distanceInput.value = "15";
		});
	});
});
